

import Vue, { unref } from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex/types/helpers';
import {  FormFields, TableHeaderModel} from  '@/models/repsol-template.model';
import { namespace } from 'vuex-class';
import { ImportLabels } from '@/models/repsol-template-aggregate.model';
import { FileData } from '@/models/file-entities.model';
import ComponentBase from '@/mixins/componentBase';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolTablePopupComponent',
    components: {

      }
})

export default class RepsolTablePopupComponent extends ComponentBase {

    isOpen = false;

    @Prop()
    headerText: string;

    @Prop()
    tableHeaders: TableHeaderModel[];

    @Prop()
    model:any[];

    @Prop()
    popupWidth: string;

    @Prop()
    changeVisibility!: boolean;
    @Watch('changeVisibility')
    changeStatus(val: boolean): void {
        this.isOpen = val;
    }

        translate(value: string, params?: Record<string, unknown>): string {
            return tUi(value, params);
        }
   
    eventAction(action:string, item:any): void{
      this.$emit("eventAction", action, item);
    }

    public mounted() {
        const popupMain = document.getElementById("popup-main");
        if(popupMain != null) {
            popupMain.style.maxWidth = this.popupWidth == undefined ? "800" : this.popupWidth + "px";
        }
    }
}

Vue.component('repsol-table-popup', RepsolTablePopupComponent);
